<template>
    <div class="localization-switcher" :class="{ 'localization-switcher_flat': isFlat }" @click.self="close">
        <LoaderBlock v-if="loading" />

        <div class="localization-switcher__modal" :class="additionalClass" v-else>
            <div class="localization-switcher__modal-tabs-close">
                <div class="localization-switcher__modal-tabs">
                    <div
                        class="localization-switcher__modal-tab"
                        :class="{ selected: activeTab === 'language' }"
                        @click="activeTab = 'language'"
                    >
                        {{ t("common.language") }}
                    </div>

                    <div
                        class="localization-switcher__modal-tab"
                        :class="{ selected: activeTab === 'currency' }"
                        @click="activeTab = 'currency'"
                    >
                        {{ t("common.currency") }}
                    </div>
                </div>

                <div v-if="!isFlat" class="localization-switcher__modal-close" @click="close">
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M0.834302 14.6001C0.584014 14.6001 0.417146 14.5167 0.250287 14.3498C-0.0834291 14.0161 -0.0834291 13.5155 0.250287 13.1818L13.1818 0.250287C13.5155 -0.0834291 14.0161 -0.0834291 14.3498 0.250287C14.6835 0.584004 14.6835 1.0846 14.3498 1.41832L1.41832 14.3498C1.25146 14.5167 1.00116 14.6001 0.834302 14.6001Z"
                        />
                        <path
                            d="M13.6824 14.6002C13.4321 14.6002 13.2653 14.5168 13.0984 14.3499L0.250287 1.50181C-0.0834291 1.1681 -0.0834291 0.6675 0.250287 0.333784C0.584004 6.69584e-05 1.0846 6.69584e-05 1.41832 0.333784L14.3498 13.2653C14.6835 13.599 14.6835 14.0996 14.3498 14.4333C14.0995 14.5168 13.9327 14.6002 13.6824 14.6002Z"
                        />
                    </svg>
                </div>
            </div>

            <div v-if="activeTab === 'language'" class="localization-switcher__modal-content">
                <div class="localization-switcher__title-switchers">
                    <div class="localization-switcher__title">{{ t("common.select_language") }}</div>

                    <div class="localization-switcher__switchers localization-switcher__switchers_langs">
                        <div
                            v-for="(locale, index) in locales"
                            class="localization-switcher__switcher"
                            :class="{ selected: locale.iso_2 === currentLocale }"
                            :key="index"
                            @click="changeLanguage(locale.iso_2)"
                        >
                            <template v-if="locale.original_name">
                                {{ locale.original_name }}
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="activeTab === 'currency'" class="localization-switcher__modal-content">
                <div class="localization-switcher__title-switchers">
                    <div class="localization-switcher__title">{{ t("common.select_currency") }}</div>

                    <div class="localization-switcher__switchers">
                        <a
                            :href="setCurrencyLink(currency.id)"
                            v-for="(currency, index) in currencies"
                            class="localization-switcher__switcher"
                            :class="{ selected: currency.id == currentCurrency.id }"
                            :key="index"
                        >
                            <div>{{ currency.name }}</div>
                            <div class="localization-switcher__switcher-grey-label">
                                {{ currency.code }} - {{ currency.html_code }}
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import keyTranslator from "../mixins/keyTranslator"
import axios from "axios"
import LoaderBlock from "./Loaders/LoaderBlock"

export default {
    name: "LocalizationSwitcher",
    components: { LoaderBlock },
    data: () => ({
        activeTab: "language",
        langsKeys: null,
        loading: true,
        locales: null,
        currencies: null,
        currentCurrency: null,
        selectCurrencyLink: null,
        localApiPrefix: null
    }),
    props: {
        apiPrefix: {
            type: String,
            default: "",
            required: false
        },
        currentLocale: {
            type: String,
            default: "",
            required: false
        },
        additionalClass: {
            type: String,
            default: "",
            required: false
        },
        isFlat: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    mixins: [keyTranslator],
    methods: {
        close() {
            this.$emit("close")
        },
        changeLanguage(val) {
            window.location = `/locale/${val}`
        },
        setCurrencyLink(id) {
            let link = `/currency/${id}`
            return link
        },
        async getCurrencies() {
            // Get currencies
            await axios.get(`${this.localApiPrefix}/currencies/main`).then(response => {
                this.currencies = response.data.data
            })

            // Get current currency
            if (window.current_currency) {
                this.currentCurrency = window.current_currency
            } else {
                await axios.get(`${this.localApiPrefix}/currencies/current`).then(response => {
                    let data = response.data.data
                    this.currentCurrency = data
                })
            }

            if (!this.currencies.find(currency => currency.id === this.currentCurrency.id)) {
                this.currentCurrency = this.currencies[0]
            }
        }
    },
    created() {
        axios.defaults.baseURL === this.apiPrefix ? (this.localApiPrefix = "") : (this.localApiPrefix = this.apiPrefix)

        if (!axios.defaults.baseURL && !this.localApiPrefix) {
            axios.defaults.baseURL = "/api/v1"
            // console.log("no base url")
        }

        let languagesUrl = `${this.localApiPrefix}/languages`

        // Get langs keys
        axios
            .get(window.cached_routes["translation-groups"], {
                params: {
                    groups: "common",
                    lang: window.app_current_locale
                },
                headers: { "X-Language": window.app_current_locale }
            })
            .then(response => {
                this.langsKeys = response.data

                // Get languages
                axios.get(languagesUrl, { params: { locale: window.app_current_locale } }).then(response => {
                    this.locales = [
                        // find actual locale and put it to the start of the list
                        response.data.data.find(locale => locale.iso_2 === this.currentLocale),
                        // add the rest of locales without actual
                        ...response.data.data.filter(locale => locale.iso_2 !== this.currentLocale)
                    ]

                    // Get currencies
                    this.getCurrencies()

                    this.loading = false
                })
            })
    }
}
</script>
<style lang="sass">
$mainFont: 'Lato'
.localization-switcher
    position: fixed
    top: 0
    left: 0
    z-index: 1000
    width: 100%
    height: 100%
    display: flex
    align-items: center
    justify-content: center
    background: rgba(240, 246, 252, 0.7)
    backdrop-filter: blur(4px)

    &_flat
        position: static
        box-shadow: 0 10px 40px rgba(128, 158, 191, 0.2)
        backdrop-filter: none
        width: 450px
        .localization-switcher__modal-tabs-close
            @media screen and ( max-width: 640px )
                height: 35px
                padding: 0 20px
        @media screen and ( max-width: 640px )
            width: 250px
        .localization-switcher__modal
            position: static
            width: 100%
            box-shadow: none
            min-height: 150px
            @media screen and ( max-width: 640px )
                max-width: 100%
                width: 100%
                min-height: 0
                transform: none
        .localization-switcher__modal-content
            padding: 20px 35px
            @media (max-width: 640px)
                padding: 15px 20px
        .localization-switcher__title
            margin-bottom: 20px
            @media screen and ( max-width: 640px )
                margin-bottom: 14px
        .localization-switcher__switchers
            margin-left: 0
            display: grid
            grid-template-columns: 1fr 1fr
            grid-gap: 20px 10px
            @media screen and ( max-width: 640px )
                grid-template-columns: 1fr
                grid-gap: 10px 10px
            &_langs
                grid-template-columns: 1fr 1fr 1fr 1fr
                @media screen and ( max-width: 640px )
                    grid-template-columns: 1fr 1fr 1fr
        .localization-switcher__switcher
            padding: 0
            transition: .3s
            font-family: $mainFont
            &:hover
                color: #FF7439
                background-color: #fff

            .loader-block
                height: 150px
                padding: 0
                background-color: #fff
                border-radius: 10px
    &__modal
        background: #FFFFFF
        box-shadow: 0 10px 40px rgba(128, 158, 191, 0.2)
        border-radius: 10px
        box-sizing: border-box
        width: 100%
        max-width: 600px
        min-height: 220px
        position: absolute
        top: 86px
        right: 30px
        @media screen and ( max-width: 640px )
            max-width: 90%
            right: unset
            left: 50% !important
            transform: translateX(-50%)

    &__modal-tabs-close
        display: flex
        justify-content: space-between
        align-items: center
        padding: 0 26px
        height: 54px
        border-bottom: 1px solid #E7ECF1

    &__modal-tabs
        display: flex
        height: 100%

    &__modal-tab
        display: flex
        align-items: center
        padding: 0 17px
        height: 100%
        cursor: pointer
        font-weight: bold
        position: relative
        color: #676E78
        font-size: 14px

        @media screen and ( max-width: 500px )
            font-size: 12px
            padding: 0 10px

        &.selected
            color: #FF7439

            &:after
                position: absolute
                bottom: -2px
                left: 0
                content: ''
                display: flex
                width: 100%
                height: 3px
                border-radius: 1.5px
                background: #FF7439

    &__modal-close
        display: flex
        cursor: pointer

        svg
            fill: #000
        &:hover
            svg
                fill: #FF7439

    &__modal-content
        padding: 27px 37px

    &__title
        color: #666E7C
        font-weight: bold
        margin-bottom: 24px
        font-size: 13px

    &__switchers
        display: flex
        flex-wrap: wrap
        margin-left: -14px

    &__switcher-grey-label
        color: #82858A
        margin-top: 3px

    &__switcher
        font-size: 15px
        color: #2B2B2B
        font-family: $mainFont
        cursor: pointer
        padding: 10px 14px
        border-radius: 5px
        @media screen and ( max-width: 500px )
            font-size: 13px

        &.selected
            color: #FF7439

            .localization-switcher__switcher-grey-label
                color: #FF7439

        &:hover
            background: rgba(240, 246, 252, 0.8)
</style>
